import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "AID_TARGETING",
  title: defineMessage({
    id: "fig.finance.AID_TARGETING.title",
    defaultMessage: `Aid to education as % of GNI, and share going to low-income countries and to basic education`,
  }),
  caption: defineMessage({ id: "fig.finance.AID_TARGETING.caption", defaultMessage: `` }),
  source: defineMessage({
    id: "fig.finance.AID_TARGETING.source",
    defaultMessage: `GEM Report team analysis based on OECD CRS`,
  }),
};
